import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Optimizechicago() {
  return (
    <section className="leading_miami tekrevol_dark_bg">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              TekRevol Is Leading the Way Forward for Mobile App Development in
              Miami
            </h2>
            <p>
              TekRevol’s app development services aren’t just offering
              standalone application services. The industry leaders we have at
              our top management continue to keenly monitor the latest trends in
              the digital tech space and can perfectly guide you in building
              your next million-dollar app idea. For Miami’s businesses, this
              represents the perfect opportunity to capitalize on the city’s
              growing need for digital solutions in the mobile app economy.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book A Consultation Now
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center"
          >
            <div className="leading_miami_img">
              <StaticImage
                src="../../images/location_new/miami/leading_miami.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={415}
                height={705}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Optimizechicago;
